<template>
    <div class="mission-value-section">
        <div class="container">
            <div class="content-wrapper">
                <div class="image-container">
                    <div class="image-wrapper">
                        <img src="/wp-content/uploads/2024/02/aboput-us-new.png" alt="Trade with Socrates Confidence"
                            class="main-image">
                    </div>
                </div>
                <div class="text-container">
                    <div class="tabs-navigation">
                        <button v-for="tab in tabs" :key="tab.id"
                            :class="['tab-button', { active: activeTab === tab.id }]" @click="activeTab = tab.id">
                            {{ tab.label }}
                        </button>
                    </div>
                    <div class="tab-content">
                        <div v-if="activeTab === 'about'" class="content-text">
                            <p>
                                <strong>Socrates Legacy</strong> is a combination of individuals with reliable trading
                                skills, experienced business people, and experts who produce sophisticated technology,
                                to make it easier for you to profit from Forex trading.
                            </p>
                            <p>
                                Socrates Legacy redefines brokerage with <strong>a unique blend </strong>of skilled
                                traders, seasoned
                                business professionals, and tech experts. This dynamic collaboration aims to
                                <strong>simplify
                                    and enhance </strong>your Forex trading experience. Our team’s reliable trading
                                skills, strategic
                                business acumen, and cutting-edge technological solutions collectively work to
                                facilitate and optimize your journey, making profitability in Forex trading more
                                accessible and efficient. Choose Socrates Legacy for a <strong>comprehensive approach
                                    that
                                    prioritizes your success</strong> in the ever-evolving world of Forex.
                            </p>
                        </div>

                        <div v-if="activeTab === 'vision'" class="content-text">
                            <p>
                                <strong>Socrates Legacy</strong> was established with the goal of creating a system with
                                <strong>comfortable
                                    trading environment</strong> and allowing traders to fully concentrate on their
                                trades. At
                                Socrates legacy, our vision revolves around creating an environment where traders can
                                thrive with undivided attention on their trades.
                            </p>
                            <p>
                                Through the adoption of a 100% <strong>Straight Through Processing (STP)</strong>
                                methodology to
                                <strong>Liquidity Providers (LPs)</strong>, Socrates has established a foundation for
                                seamless and
                                efficient trading experiences. This vision underscores our mission to <strong>provide
                                    traders</strong>
                                with the tools and environment they need to concentrate fully on their strategies,
                                fostering success in the dynamic world of trading.
                            </p>
                        </div>

                        <div v-if="activeTab === 'mission'" class="content-text">
                            <p>
                                Socrates undertakes a steadfast mission to attain Prime Bank Liquidity Provider status
                                <strong>(we’re at Tier-1 Liquidity Provider status right now)</strong>, an achievement
                                meticulously
                                crafted to enhance pricing dynamics across the entire spectrum of trading.
                            </p>
                            <p>
                                Our primary mission extends beyond mere acknowledgment as a top-tier liquidity provider;
                                it delves deeper into a commitment to translate this success into tangible advantages
                                for traders who entrust their investments. This encompasses significant <strong>
                                    enhancements in
                                    pricing structures, special offers, and various other</strong> advantages designed
                                to empower
                                every trading move made by our users. <strong>Success achieved</strong> resonates as
                                practical benefits
                                for those navigating the dynamic landscape of the trading world through Socrates.
                            </p>
                        </div>

                        <div v-if="activeTab === 'value'" class="content-text">
                            <p>
                                In a relatively short period, specifically three years, Socrates has successfully forged
                                partnerships with <strong>Tier-1 Liquidity Providers</strong>, establishing a robust
                                foundation for
                                future growth and development.
                            </p>
                            <p>
                                This accomplishment signifies <strong>our commitment to delivering excellent services
                                    and
                                    supporting the success of traders</strong> who entrust their trading activities to
                                us.
                                Recognizing the paramount importance of speed and responsiveness in the dynamic world of
                                trading, Socrates takes pride in demonstrating our ability to adapt and evolve swiftly
                                in response to market demands within a concise timeframe. Through this achievement,
                                <strong>we
                                    are confident</strong> that Socrates will continue to be the preferred choice for
                                traders seeking
                                superior performance and ease of transactions.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MissionValue',
    data() {
        return {
            activeTab: 'about',
            tabs: [
                { id: 'about', label: 'About Us' },
                { id: 'vision', label: 'Vision' },
                { id: 'mission', label: 'Mission' },
                { id: 'value', label: 'Our Value' }
            ]
        }
    }
}
</script>

<style scoped>
.mission-value-section {
    background-color: #f5f5f5;
    padding: 60px 0;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.content-wrapper {
    display: grid;
    grid-template-columns: 45% 55%;
    gap: 60px;
    align-items: center;
}

/* Left Side - Image */
.image-container {
    position: relative;
}


.main-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
}


/* Right Side - Tabs & Content */
.text-container {
    background: #faf6ee;
    border-radius: 15px;
    padding: 40px;
}

.tabs-navigation {
    display: flex;
    gap: 10px;
    margin-bottom: 30px;
    flex-wrap: wrap;
}

.tab-button {
    background: none;
    border: none;
    padding: 12px 20px;
    font-size: 16px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    border-bottom: 3px solid transparent;
}

.tab-button:hover {
    color: #D4AF37;
}

.tab-button.active {
    color: #D4AF37;
    border-bottom-color: #D4AF37;
}

.tab-content {
    animation: fadeIn 0.4s ease-in-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.content-text {
    color: #333;
    line-height: 1.8;
    font-size: 16px;
}

.content-text p {
    margin-bottom: 20px;
}

.content-text strong {
    color: #D4AF37;
    font-weight: 700;
}

.content-text ul {
    margin: 20px 0;
    padding-left: 25px;
}

.content-text li {
    margin-bottom: 12px;
    color: #555;
}

/* Responsive Design */
@media (max-width: 1024px) {
    .content-wrapper {
        grid-template-columns: 1fr;
        gap: 40px;
    }

    .image-container {
        order: 1;
    }

    .text-container {
        order: 2;
        padding: 30px;
    }
}

@media (max-width: 768px) {
    .mission-value-section {
        padding: 50px 0;
    }

    .text-container {
        padding: 25px;
    }

    .tabs-navigation {
        gap: 5px;
    }

    .tab-button {
        padding: 10px 15px;
        font-size: 14px;
    }

    .content-text {
        font-size: 15px;
    }

    .image-badge {
        bottom: 20px;
        left: 20px;
        padding: 12px 20px;
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .mission-value-section {
        padding: 40px 0;
    }

    .container {
        padding: 0 15px;
    }

    .text-container {
        padding: 20px;
    }

    .tabs-navigation {
        flex-direction: column;
        gap: 0;
        border-bottom: none;
    }

    .tab-button {
        width: 100%;
        text-align: left;
        padding: 15px;
        border-bottom: 1px solid #e0e0e0;
        border-left: 3px solid transparent;
    }

    .tab-button.active {
        border-bottom-color: #e0e0e0;
        border-left-color: #D4AF37;
        background: #fafafa;
    }

    .content-text {
        font-size: 14px;
    }

    .image-badge {
        font-size: 12px;
        padding: 10px 15px;
        bottom: 15px;
        left: 15px;
    }
}
</style>
